const PropTypes = require("prop-types");
/**
 * Created by adderlyjaureguicampos on 08/12/16.
 */
const React = require("react");

const { FormattedText, formatText } = require("core/i18n").i18n;
const OKSelect = require("components/commons/OKSelect/OKSelect");
const { InputSafe } = require("commonsComponents/inputSafe");
 
// @utillities
import { 
    fiocFiscalCountrySelectedTagging,
    fiocPurposeOfTaxationSelectedTagging,
    fiocPurposeOfTaxationClickTagging,
    fiocTinChangeTagging,
    fiocRemoveTaxationTagging,
    fiocPurposeOfTaxationCloseTagging,
    fiocPurposeOfTaxationOpenTagging,
} from  'utilities/taggingInfo/fiocTags';

require("./TaxationData.scss");

class TaxationData extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleChangeReason = this.handleChangeReason.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.handleTin = this.handleTin.bind(this);
        this.handleBlurTin = this.handleBlurTin.bind(this);
    }

    handleFocus(event) {
        const { handleFocus } = this.props;
        handleFocus && handleFocus(event);
    }

    handleBlur(event) {
        const formId = this.props.formId;
        this.props.handleBlur(event, formId);
    }

    handleChange(event) {
        const formId = this.props.formId;
        this.props.handleChange(event, formId);
    }

    handleRemove() {
        const formId = this.props.formId;
        this.props.handleRemove(formId);
        fiocRemoveTaxationTagging();
    }

    handleTin(event) {
        const formId = this.props.formId;
        this.props.handleChangeTin(event, formId);
    }

    handleBlurTin(event) {
        const { formId } = this.props;
        this.props.handleChangeTin(event, formId);
        fiocTinChangeTagging();
    }

    buildFirstTaxationCountryTitle = () => {
        return (
            <div className="ok-slider__text">
                {formatText(
                    "contractsView-checkingAccountTaxationDataFirstTaxationCountry"
                )}
            </div>
        );
    };

    
    handleChangeCountry = (event) => {
        const formId = this.props.formId;
        this.props.handleChange(event, formId);
        fiocFiscalCountrySelectedTagging(event.label);
    }

    handleChangeReason = (event) => {
        fiocPurposeOfTaxationSelectedTagging(event.label);
        const formId = this.props.formId;
        this.props.handleChange(event, formId);
    }

    handleFocusReason = () => {
        fiocPurposeOfTaxationClickTagging();
        fiocPurposeOfTaxationOpenTagging();
    }

    buildFirstTaxationCountryDesc = (formId, errors) => {
        const idContry = "contry_" + formId;
        const errorMessageCountry = (
            <FormattedText value="contractsView-countryRequiredError" />
        );
        return (
            <OKSelect
                placeholder={formatText(
                    "contractsView-checkingAccountTaxationDataFirstTaxationCountryPlaceholder"
                )}
                searchable={true}
                options={this.props.taxCountryOptions}
                onChange={this.handleChangeCountry}
                value={this.props.formData.taxCountry}
                id={idContry}
                errorMessage={errorMessageCountry}
                errorState={errors["taxCountry"]}
                onFocusFunc={this.handleFocus}
                onBlur={this.handleBlur}
            />
        );
    };

    buildTaxationReasonTitle = () => {
        return (
            <div className="ok-slider__text">
                {formatText(
                    "contractsView-checkingAccountTaxationDataIndicatorTaxationReason"
                )}
            </div>
        );
    };

    buildTaxationReasonDesc = (formId, errors) => {
        const idReason = "reason_" + formId;
        const errorMessage = (
            <FormattedText value="contractsView-listRequiredError" />
        );
        return (
            <OKSelect
                placeholder={formatText(
                    "contractsView-checkingAccountTaxationDataIndicatorTaxationReasonPlaceholder"
                )}
                searchable={true}
                options={this.props.imtOptions}
                onChange={this.handleChangeReason}
                value={this.props.formData.imt}
                id={idReason}
                errorMessage={errorMessage}
                errorState={errors["imt"]}
                onBlur={fiocPurposeOfTaxationCloseTagging}
                onFocusFunc={this.handleFocusReason}
            />
        );
    };

    buildDataInputTitle = () => {
        return (
            <div className="ok-slider__text">
                {formatText(
                    "contractsView-checkingAccountTaxationDataInputTitle"
                )}
            </div>
        );
    };

    buildDataInputDesc = (formId, errors) => {
        const idTin = "tin_" + formId;
        const { tin } = this.props.formData;

        const manageErorrsTin = () => {
            if (errors["tin"]) {
                return (
                    <FormattedText value="profile-incompletetaxingCountryDocumentID" />
                );
            }

            if (errors["valid"]) {
                return (
                    <FormattedText value="profile-invalidtaxingCountryDocumentID" />
                );
            }
        };

        return (
            <InputSafe
                label={null}
                name="tin"
                onChange={this.handleTin}
                onBlur={this.handleBlurTin}
                referenceName="tin"
                type="text"
                value={tin}
                id={idTin}
                errorMessage={manageErorrsTin()}
                errorState={errors["valid"] || errors["tin"]}
            />
        );
    };

    render() {
        const { errorState, formId } = this.props;
        const errors = errorState.get ? errorState.toJS() : errorState;
        let idTax = "tax_" + formId;
        let classRemoveTax = this.props.showRemove ? "remove-tax" : "hidden";

        return (
            <div className="taxation-data-form" id={idTax} key={idTax}>
                <div className={classRemoveTax}>
                    <a href="javascript:void(0);" onClick={this.handleRemove}>
                        <i className="icon icon-remove"></i>
                        {formatText(
                            "contractsView-checkingAccountTaxationDataIndicatorTaxationRemove"
                        )}
                    </a>
                </div>
                <div className="desktop-version">
                    <div className="row">
                        <div className="col-xs-4">
                            {this.buildFirstTaxationCountryTitle()}
                        </div>
                        <div className="col-xs-4">
                            {this.buildTaxationReasonTitle()}
                        </div>
                        <div className="col-xs-4">
                            {this.buildDataInputTitle()}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">
                            {this.buildFirstTaxationCountryDesc(formId, errors)}
                        </div>
                        <div className="col-xs-4">
                            {this.buildTaxationReasonDesc(formId, errors)}
                        </div>
                        <div className="col-xs-4">
                            {this.buildDataInputDesc(formId, errors)}
                        </div>
                    </div>
                </div>
                <div className="mobile-tablet-version">
                    <div className="">
                        {this.buildFirstTaxationCountryTitle()}
                        {this.buildFirstTaxationCountryDesc(formId, errors)}
                    </div>
                    <div className="">
                        {this.buildTaxationReasonTitle()}
                        {this.buildTaxationReasonDesc(formId, errors)}
                    </div>
                    <div className="">
                        {this.buildDataInputTitle()}
                        {this.buildDataInputDesc(formId, errors)}
                    </div>
                </div>
            </div>
        );
    }
}

TaxationData.propTypes = {
    taxCountryOptions: PropTypes.array,
    imtOptions: PropTypes.array,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    handleFocus: PropTypes.func,
    handleRemove: PropTypes.func,
    formData: PropTypes.object,
    formId: PropTypes.any.isRequired,
    showRemove: PropTypes.bool.isRequired,
    errorState: PropTypes.any.isRequired,
};

module.exports = TaxationData;
